/**
 * Base URL for the Nest API (no trailing slash).
 * Set `VITE_API_URL` in `.env` / `.env.local` (Vite exposes only `VITE_*` to the client).
 * Empty string is treated as unset.
 */
export function getApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_URL?.trim();
  if (raw) return raw.replace(/\/$/, "");
  if (import.meta.env.DEV) {
    return "http://localhost:3001";
  }
  return "http://localhost:3001";
}
